<template>
    <card style="background-color:#e9ecef;">
      <h5>{{ $t("title") }}</h5>

     <div v-if="!sent">

      {{ $t("info") }}
      <br/>
      <br/>

      <small class="text-uppercase font-weight-bold">{{
        $t("openfeedback")
      }}</small>
      <br/>

      <base-input
        maxLength="5000"
        id="input-openfeedback"
        class="mb-3"
        v-model="form.openfeedback"
        v-bind:placeholder="$t('openfeedback')"
      />

      <small class="text-uppercase font-weight-bold">{{
        $t("learn")
      }}</small>
      <br/>

      <base-input
        maxLength="5000"
        id="input-learn"
        v-model="form.learn"
        class="mb-3"
        v-bind:placeholder="$t('learn')"
      />

      <small class="text-uppercase font-weight-bold">{{
        $t("recommend")
      }}</small>
      <br/>

      <base-button
        v-for="i in 10"
        :key="i"
        size="md"
        type="info"
        :class="form.selected === i ? 'active' : ''"
        style="margin: 5px"
        v-on:click="form.selected=i"
        >{{ i }}
      </base-button>

      <br/>
      <br/>

      </div>

      <base-button style="white-space: normal;"
        type="success"
        v-on:click="onSubmit()"
        :disabled="disableSubmit"
        >{{ sent ? $t("thankyou") : $t("submit") }}</base-button
      >
    </card>
</template>

<script>
import {
  sendFeedback,
} from "../services/APIService";

const validator = require("email-validator");

export default {
  data: function () {
    return {
      form: {
        learn: null,
        openfeedback: null,
        selected: 0,
      },
      sent: false,
    };
  },
  computed: {
    disableSubmit() {
      if (this.sent) {
        return true;
      }

      if (!this.form.learn && !this.form.openfeedback && this.form.selected === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    onSubmit() {
      sendFeedback(this.form.learn, this.form.openfeedback, this.form.selected, this.$store.state.main.game.id, this.$store.state.main.game.gameCode, this.$i18n.locale)
      this.sent = true;
    },
  },
};
</script>

<i18n>
{
  "en": {
    "title": "Feedback form",
    "info": "Feedback is collected anonymously and provided to the tool developers and the simulation facilitator.",
    "openfeedback": "Open feedback about the simulation tool",
    "learn": "What did you learn in the simulation?",
    "recommend": "How likely is it that you would recommend this tool to a friend or colleague?",
    "submit": "Submit",
    "thankyou": "Thank you!"
  },
  "fi": {
    "title": "Palautelomake",
    "info": "Palaute kerätään nimettömänä ja välitetään simulaation pelinjohtajalle ja SmoothTeamille.",
    "openfeedback": "Avointa palautetta simulaatiosta",
    "learn": "Mitä opit simulaatiossa?",
    "recommend": "Kuinka todennäköisesti suosittelisit simulaatiota ystävällesi tai työkaverillesi?",
    "submit": "Lähetä",
    "thankyou": "Kiitos!"
  },
  "sv": {
    "title": "Feedbackformulär",
    "info": "Feedback samlas in anonymt till utvecklarna av verktyget och till spelledaren.",
    "openfeedback": "Öppna feedbackformuläret om simuleringsverktyget",
    "learn": "Vad lärde du dig under simuleringen?",
    "recommend": "Hur sannolikt är det att du skulle rekommendera detta verktyg till en vän eller kollega?",
    "submit": "Slutför",
    "thankyou": "Tack för hjälpen"
  },
  "de": {
    "title": "Feedback-Formular",
    "info": "Das Feedback wird anonym gesammelt und den Tool-Entwicklern und dem Simulationsvermittler zur Verfügung gestellt.",
    "openfeedback": "Offenes Feedback zum Simulationswerkzeug",
    "learn": "Was hast du in der Simulation gelernt?",
    "recommend": "Wie wahrscheinlich ist es, dass Sie dieses Tool einem Freund oder Kollegen empfehlen?",
    "submit": "Einreichen",
    "thankyou": "Vielen Dank!" 
  },
  "ko": {
      "title": "피드백 설문",
      "info": "답변하여 주신 내용은 익명으로 시뮬레이션 개발자 및 퍼실리테이터에게 전달됩니다.",
      "openfeedback": "시뮬레이션에 대한 피드백을 자유롭게 남겨주세요.",
      "learn": "이 과정을 통해 무엇을 배우셨습니까?",
      "recommend": "시뮬레이션을 친구 혹은 동료에게 추천하시겠습니까?",
      "submit": "제출",
      "thankyou": "감사합니다."
  }  
}
</i18n>
